import { X } from "@phosphor-icons/react";

export default function KpiFilterBanner({ filterMeta, filterIds, filteredCount, onClear }) {
  if (!filterMeta) return null;
  return (
    <div
      className="flex items-center justify-between gap-3 mb-4 px-4 py-3 rounded-lg border"
      style={{
        backgroundColor: `${filterMeta.accent}10`,
        borderColor: `${filterMeta.accent}33`,
      }}
      data-testid="kpi-filter-banner"
    >
      <div className="flex items-center gap-3 min-w-0">
        <filterMeta.icon size={18} weight="duotone" style={{ color: filterMeta.accent }} />
        <div className="min-w-0">
          <p className="text-sm font-semibold" style={{ color: filterMeta.accent }}>
            Filtro attivo: {filterMeta.label}
            {filterIds && (
              <span className="ml-2 text-zinc-400 font-normal">
                · {filteredCount} {filteredCount === 1 ? "cliente" : "clienti"}
              </span>
            )}
          </p>
          <p className="text-[11px] text-zinc-500 truncate">{filterMeta.description}</p>
        </div>
      </div>
      <button
        type="button"
        onClick={onClear}
        className="flex items-center gap-1 text-xs text-zinc-400 hover:text-white px-2 py-1 rounded-md hover:bg-white/5 transition-colors flex-shrink-0"
        data-testid="kpi-filter-clear"
      >
        <X size={14} /> Rimuovi filtro
      </button>
    </div>
  );
}
